module.exports = __webpack_public_path__ + "media/images/sign_up_illustration-91346870dd3dc65e59d27361255ace45.png";